module.exports = __webpack_public_path__ + "static/media/landscape.59e156a3.jpg";